/**
 * Delivery Date Sync
 *
 * Keeps all delivery date pickers (product page + cart drawer/page) in sync
 * by storing the value as a cart attribute via the Shopify Cart API.
 *
 * Any input with [data-delivery-date-sync] participates in synchronisation.
 * The attribute name is read from data-delivery-date-attribute on each input.
 */

if (!customElements.get('delivery-date-sync')) {
  class DeliveryDateSync extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('[data-delivery-date-sync]');
      if (!this.input) return;

      this.attributeName = this.input.dataset.deliveryDateAttribute || 'Preferred Delivery Date';
      this.input.addEventListener('change', this.onDateChange.bind(this));

      document.addEventListener('theme:cart:change', this.onCartChange.bind(this));
    }

    onDateChange() {
      const value = this.input.value;
      this.syncAllInputs(value);
      this.updateCartAttribute(value);
    }

    syncAllInputs(value) {
      document.querySelectorAll('[data-delivery-date-sync]').forEach((input) => {
        if (input !== this.input && input.value !== value) {
          input.value = value;
        }
      });
    }

    updateCartAttribute(value) {
      const body = {
        attributes: {
          [this.attributeName]: value,
        },
      };

      fetch(window.theme?.routes?.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      }).catch((error) => {
        console.error('[Delivery Date] Failed to update cart attribute:', error);
      });
    }

    onCartChange() {
      fetch(window.theme?.routes?.cart_url || '/cart.js', {
        method: 'GET',
        headers: {Accept: 'application/json'},
      })
        .then((response) => response.json())
        .then((cart) => {
          const value = cart.attributes?.[this.attributeName] || '';
          if (this.input.value !== value) {
            this.input.value = value;
          }
        })
        .catch(() => {});
    }
  }

  customElements.define('delivery-date-sync', DeliveryDateSync);
}
